import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authdApiRequest } from '../utils/api';

function Snapshots() {
  const [snapshots, setSnapshots] = useState([]);
  const navigate = useNavigate();

  const fetchSnapshots = async () => {
    try {
      const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys`);
      const data = await response.json();
      setSnapshots(data);
    } catch (error) {
      console.error('Error fetching snapshots:', error);
      toast.error('Failed to load snapshots.');
    }
  };

  useEffect(() => {
    document.title = 'Snapshots - DevWing';
    fetchSnapshots();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleCloseSnapshot = async (snapshotId) => {
    if (window.confirm('Are you sure you want to close this snapshot?')) {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${snapshotId}/close`, {
          method: 'POST',
        });
        if (response.ok) {
          toast.success(`Snapshot ${snapshotId} closed successfully.`);
          fetchSnapshots(); // Re-fetch snapshots to update the state
        } else {
          console.error('Failed to close the snapshot.');
          toast.error('Error closing snapshot.');
        }
      } catch (error) {
        console.error('Error closing snapshot:', error);
        toast.error('Error closing snapshot.');
      }
    }
  };

  const handleProcessSnapshot = async (snapshotId) => {
    if (window.confirm('Are you sure you want to process this snapshot?')) {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${snapshotId}/process`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          toast.success(`Snapshot ${snapshotId} processed successfully.`);
          fetchSnapshots();
        } else {
          toast.error('Failed to process snapshot.');
        }
      } catch (error) {
        toast.error('Error processing snapshot.');
      }
    }
  };

  const handleReleaseSnapshot = async (snapshotId) => {
    if (window.confirm('Are you sure you want to release this snapshot?')) {
      try {
        const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/surveys/${snapshotId}/release`, {
          method: 'POST',
        });
        if (response.ok) {
          toast.success(`Snapshop ${snapshotId} released successfully.`);
          fetchSnapshots(); // Re-fetch snapshots to update the state
        } else {
          console.error('Failed to release the snapshot.');
          toast.error('Error releasing snapshot.');
        }
      } catch (error) {
        console.error('Error releasing snapshot:', error);
        toast.error('Error releasing snapshot.');
      }
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl mb-8 font-bold">Snapshots</h1>
      <button
        onClick={() => navigate('/snapshots/create')}
        className="mb-4 py-2 px-4 rounded-md text-white bg-sky-500"
      >
        Create New Snapshot
      </button>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="text-left py-2 border-b-2 border-zinc-700">Title</th>
            <th className="py-2 border-b-2 border-zinc-700"></th>
          </tr>
        </thead>
        <tbody>
          {snapshots.map((snapshot) => (
            <tr key={snapshot.id}>
              <td className="border-b border-zinc-700 py-2">
                {snapshot.closed && !snapshot.processed && (
                  <span className="bg-amber-100 text-amber-800 text-xs font-bold py-1 px-2 mr-2 rounded dark:bg-red-900 dark:text-red-300">CLOSED</span>
                )}
                {snapshot.processed && !snapshot.released && (
                  <span className="bg-pink-100 text-pink-800 text-xs font-bold py-1 px-2 mr-2 rounded">PROCESSED</span>
                )}
                {snapshot.released && (
                  <span className="bg-green-100 text-green-800 text-xs font-bold py-1 px-2 mr-2 rounded">RELEASED</span>
                )}
                {snapshot.title ? (
                  `${formatDate(snapshot.endDate)} Snapshot (${snapshot.title})`
                ) : (
                  `${formatDate(snapshot.endDate)} Snapshot`
                )}
              </td>
              <td className="border-b border-zinc-700 py-2 text-right">
                {snapshot.closed && snapshot.processed && (
                  <button
                    onClick={() => navigate(`/snapshots/${snapshot.id}/results`)}
                    className="bg-green-500 px-2 py-1 ml-2 text-white text-sm rounded-md"
                  >
                    Results
                  </button>
                )}
                {!snapshot.closed && !snapshot.processed && (
                  <button
                    onClick={() => navigate(`/snapshots/view/${snapshot.id}`)}
                    className="bg-zinc-500 px-2 py-1 ml-2 text-sm text-white rounded-md"
                  >
                    Status
                  </button>
                )}
                {!snapshot.closed && (
                  <button
                    onClick={() => navigate(`/snapshots/edit/${snapshot.id}`)}
                    className="bg-sky-500 px-2 py-1 ml-2 text-sm text-white rounded-md"
                  >
                    Edit
                  </button>
                )}
                {!snapshot.closed && (
                  <button
                    onClick={() => handleCloseSnapshot(snapshot.id)}
                    className="bg-amber-500 px-2 py-1 ml-2 text-white text-sm rounded-md"
                  >
                    Close
                  </button>
                )}
                {snapshot.closed && !snapshot.processed && (
                  <button
                    onClick={() => handleProcessSnapshot(snapshot.id)}
                    className="bg-indigo-500 px-2 py-1 ml-2 text-white text-sm rounded-md"
                  >
                    Process
                  </button>
                )}
                {snapshot.closed && snapshot.processed && !snapshot.released && (
                  <button
                    onClick={() => handleReleaseSnapshot(snapshot.id)}
                    className="bg-pink-500 px-2 py-1 ml-2 text-white text-sm rounded-md"
                  >
                    Release
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Layout>
  );
}

export default Snapshots;
